import React from 'react';
import EventCard from './EventCard';

export default function EventUpcoming(props) {
    // Array to iterate 5 times
    console.log(props.Events);

  return (
    ( props.Events.length === 0 )?
      <div className="event-list">
        <h1>No Upcoming Events</h1>
      </div>
  :
    <div className="event-list">
        {props.Events.map(event => (
        <EventCard key={event._id} day={event.date.split('-')[0]} date={event.date.split('-')[1]} month={event.date.split('-')[2]} time={event.time} venue={event.venue} contact={event.contacts} title={event.title} description={event.description} isPast={false} />
      ))}
    </div>
  );
}

